export type ArticlePlacement =
	| "feed"
	| "headline"
	| "popular"
	| "feature"
	| "saved"
	| "source_directory";

/** 計測用の公開記事情報だけを生成する。URLが不正ならnull。タイトル・個人情報は送らない。 */
export function articleEvent(articleId: string, href: string, placement: ArticlePlacement) {
	try {
		const url = new URL(href);
		if (!/^\d+$/.test(articleId) || !["http:", "https:"].includes(url.protocol)) return null;
		return { article_id: articleId, link_domain: url.hostname, placement };
	} catch {
		return null;
	}
}

/** GA4が利用可能な場合だけイベントを送る。未同意・未読込・ブロック時も閲覧を妨げない。 */
export function trackReaderEvent(name: string, parameters: Record<string, string>) {
	if (typeof window === "undefined" || !window.SiteAnalytics?.allowed) return;
	const analyticsWindow = window as Window & {
		dataLayer?: unknown[];
		gtag?: (...args: unknown[]) => void;
	};
	try {
		if (analyticsWindow.gtag) {
			analyticsWindow.gtag("event", name, parameters);
			return;
		}
		// 外部スクリプトの読込前でも、初期化済みキューがあればイベントを失わない。
		analyticsWindow.dataLayer?.push(["event", name, parameters]);
	} catch {
		/* 計測失敗はUIへ波及させない。 */
	}
}
